module.exports = __webpack_public_path__ + "img/share-tips.832cb4fd.png";